import { render, staticRenderFns } from "./StaffRecord.vue?vue&type=template&id=6c3aaa4c&scoped=true&"
import script from "./StaffRecord.vue?vue&type=script&lang=js&"
export * from "./StaffRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3aaa4c",
  null
  
)

export default component.exports